module.exports = __webpack_public_path__ + "media/images/dust_box-253f12d40d5ecec1186a84004c4938ab.svg";